import axios from "axios";
export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        fetchPlans() {
            return axios.get("app/plans");
        },
    },
};
